import React from 'react';
import BasicField from 'components/content/shared/fields/BasicField';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import { IProduct } from 'types/backend_models/products/IProduct';
import { toYearAndMonthDateBE } from 'functions/formatters/date';

interface IProps
{
	product: IProduct | null
}

export function ProductDetailInfo(props: IProps)
{
	const labelClassName = "col-m-6";
	const valueClassName = "col-m-6";

	if (!props.product) {
		return null;
	} else {
		const product = props.product;

		return (
			<>
				<ContainerSectionTitle>Product info</ContainerSectionTitle>
				<BasicField
					label="KEY REF"
					value={product.keyRef}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>

				<BasicField
					label="Customer REF"
					value={product.customerRef}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Customer Description"
					value={product.customerDescription}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="ISA REF"
					value={product.isaRef}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>

				<BasicField
					label="Lot Number"
					value={product.lotNumber}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>

				<BasicField
					label="Expiry Date"
					value={toYearAndMonthDateBE(product.expiryDate)}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
			</>
		);
	}
}